import app from 'app';
import timemachineTaskManager from 'v/Story/Timeline/api/timemachineTaskManager';
import { workPool } from '@wochitnpm/helpers';

/**
 * @namespace workPool.job.audiowaveform
 */
export default workPool.define(
  'audiowaveform',
  {
    initialize() {
      const { asset } = this.options;
      const waveformSourceId = asset.metadata.assetUUID;
      const waveformSource = app.api.waveform.getSourceType(asset);
      this.firebaseKey = `${waveformSource}-${waveformSourceId}`;
      this.startTime = ~~(Date.now() / 1000);
    },

    getContext() {
      return {
        assetId: this.options.asset.metadata.assetUUID,
      };
    },

    run() {
      const thenCreate = new _.ColdPromise();
      const { asset, checkIfExists } = this.options;

      if (checkIfExists) {
        app.api.waveform.check(asset).then(
          (res) => {
            if ('DONE' === res.status) {
              this.onDone(res);
            } else if ('FAILED' === res.status) {
              thenCreate.resolve(); // retry
            } else {
              this.waitTillDone(asset);
            }
          },
          (err) => {
            thenCreate.resolve(); // retry
          }
        );
      } else {
        thenCreate.resolve();
      }

      thenCreate.then(() => {
        app.api.waveform.create(asset).then(
          () => {
            this.waitTillDone(asset);
          },
          (err) => {
            this.onError(`failed to create ${JSON.stringify(err)}`);
          }
        );
      });
    },

    waitTillDone(asset) {
      this.waitWaveformAtFirebase().then(
        () => {
          console.log(
            `${this.getContext().assetId}: waveform creation took (sec): `,
            ~~(Date.now() / 1000) - this.startTime
          );
          app.api.waveform.check(asset).then(
            (res) => {
              if (res.status === 'DONE') {
                this.onDone(res);
              } else {
                this.onError('readiness status out of sync');
              }
            },
            (err) => {
              this.onError(
                `failed to check after firebase done ${JSON.stringify(err)}`
              );
            }
          );
        },
        () => {
          this.onError('firebase reported failure');
        }
      );
    },

    onDone(res) {
      const { asset } = this.options;
      this.$emit({
        duration: asset.metadata.duration,
        ...res,
      });
      this.finish();
    },

    onError(err) {
      app.doctorController.report(`audiowaveform: ${err}`);
      this.abort();
    },

    waitWaveformAtFirebase() {
      const promise = new _.ColdPromise();

      console.log(`[now] waitWaveformAtFirebase ${this.firebaseKey}`);

      app.api.realTime.listenOn({
        path: `/waveforms/${this.firebaseKey}`,
        callback: ({ val }) => {
          console.log(`[${val.data}] waitWaveformAtFirebase`);
          const timeStamp = val.timestamp;
          if (timeStamp - this.startTime < 0) {
            // ignore old message
          } else if (val.data === 'DONE') {
            promise.resolve();
          } else if (val.data === 'FAILED') {
            promise.reject();
          }
        },
        errorCallback: promise.reject,
      });

      promise.finally(() => {
        app.api.realTime.cancelListen(`/waveforms/${this.firebaseKey}`);
      });

      return promise;
    },
  },
  {
    isRunning(asset) {
      return workPool.has({
        type: this.type,
        context: (jc) => jc.assetUUID === asset.metadata.assetUUID,
      });
    },

    execute({ asset, checkIfExists }) {
      const isRunning = this.isRunning(asset);

      if (!isRunning) {
        workPool.add(new this({ asset, checkIfExists }));
      }
    },

    loadWaveformData(payload) {
      timemachineTaskManager
        .loadJson({
          waveformSourceId: payload.waveformSourceId,
          jsonUrl: payload.cdnUrl,
          duration: payload.duration,
        })
        .then((success) => {
          app.rootStore.commit('setAudioWaveForms', {
            assetUUID: payload.waveformSourceId,
            success,
          });
        });
    },
  }
);
